import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import { EXPERIENCES, HOTEL } from "@/data/hotel";

export default function Experiences() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <Seo
        title="Dining, Lawn & In-House Experiences"
        description="Everything Hotel Azulo Inn offers lives inside the property — a multi-cuisine restaurant, garden lawn, 24/7 in-room dining, and a quiet front desk in Safdarjung Enclave, New Delhi."
        path="/experiences"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="overline">The Hotel</div>
          <h1 className="mt-6 font-serif text-5xl md:text-7xl leading-[0.98] text-ink-900 max-w-3xl">
            A restaurant, a lawn,
            <span className="italic text-sage-dark"> a quiet front desk.</span>
          </h1>
          <p className="mt-8 max-w-xl text-ink-700 leading-relaxed">
            Everything Hotel Azulo Inn offers lives inside the property. Honest, well-tended, and
            never ostentatious — the way a small boutique hotel should be.
          </p>
        </Reveal>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20 grid grid-cols-1 md:grid-cols-2 gap-8">
        {EXPERIENCES.map((e, i) => (
          <Reveal key={e.title} delay={i * 0.05}>
            <div className="bg-paper-100 p-10 md:p-12 h-full border hairline">
              <div className="overline">{e.kind}</div>
              <h3 className="mt-5 font-serif text-3xl md:text-4xl text-ink-900">{e.title}</h3>
              <p className="mt-5 text-ink-700 leading-relaxed">{e.blurb}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-32 max-w-7xl mx-auto px-6 md:px-12">
        <div className="bg-sage-deep text-paper-50 py-20 px-8 md:px-16">
          <div className="grid md:grid-cols-12 gap-10 items-end">
            <div className="md:col-span-7">
              <div className="text-[11px] tracking-[0.24em] uppercase text-sage-light">Private events</div>
              <h3 className="mt-4 font-serif text-3xl md:text-5xl">
                Take the lawn for an evening.
              </h3>
              <p className="mt-6 max-w-lg text-paper-200/85 leading-relaxed">
                The garden lawn, the restaurant, and select rooms can be booked for small
                gatherings, working dinners, and family functions.
              </p>
            </div>
            <div className="md:col-span-5 md:text-right">
              <a
                href={`mailto:${HOTEL.email}?subject=Private%20event%20enquiry`}
                data-testid="experiences-events-btn"
                className="inline-flex items-center h-12 px-8 bg-paper-50 text-sage-deep text-[11px] tracking-[0.22em] uppercase hover:bg-paper-200 transition-colors"
              >
                Enquire about an event
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
